<button class="btn btn-sm btn-danger ms-1 hide-print"
        [ngClass]="{ 'py-0 px-1': size === 'xs' }"
        data-bs-toggle="tooltip" data-placement="top" title="Delete">
  <i class="fa fa-trash"></i>
</button>